<template>
    <div class="header-drop" :class="{ 'header-drop--open': isOpen }">
        <span class="header-drop__overlay" @click="handleDropper"></span>
        <span class="header-drop__label" @click="handleDropper">
            {{ menuLabel }}
            <!-- <span class="header-drop__label__arrow">
                <VueFeather type="chevron-down" />
            </span> -->
            <span class="toggler" :class="{ 'toggler--active': isTogglerToggled, 'display-toggle': !isMobile }">
                <span class="toggler__line"></span>
                <span class="toggler__line"></span>
                <span class="toggler__line"></span>
            </span>
        </span>

        <div
            class="header-drop__dropper"
            :class="{
                'header-drop__dropper--open': isOpen,
                'header__drop__dropper--employ': currentDepartment?.type === DepartmentType.Employ,
            }"
        >
            <h3 class="mobile-nav__header">FÖRETAG</h3>

            <div class="header-drop__dropper__comp">
                <div :class="companyClasses" @click="handleCompanyDropdown">
                    <div class="header-drop__dropper__comp__info__avatar">
                        <template v-if="currentDepartment">
                            <img
                                v-if="currentDepartment?.certificate_meta?.logo"
                                :src="currentDepartment.certificate_meta.logo"
                            />
                            <img v-else :src="meta.logo" alt="Default logotype" />
                        </template>
                        <div v-else class="my-account__avatar">
                            <VueFeather type="user" size="16" stroke="#fff" />
                        </div>
                    </div>

                    <h4 class="header-drop__dropper__comp__info__title">
                        {{
                            superAdminUserProfile && user?.current_profile_id === superAdminUserProfile.id
                                ? 'Superadmin'
                                : currentDepartment?.display_name || 'Mitt konto'
                        }}
                    </h4>

                    <ul
                        v-if="companyDropDownOpen && (departmentsWithSignInAccess.length > 0 || superAdminUserProfile)"
                        class="header-drop__dropper__comp__info__list"
                    >
                        <li
                            v-for="(dep, index) in departmentsWithSignInAccess"
                            :key="`dep-${index}`"
                            class="header-drop__dropper__comp__info__list__item"
                            @click="handleSwitchCompany(dep)"
                        >
                            <span class="header-drop__dropper__comp__info__list__item--company-name">{{
                                dep.display_name
                            }}</span>
                            <span class="header-drop__dropper__comp__info__list__item--company-profile-email">{{
                                dep.user_profile.email
                            }}</span>
                        </li>
                        <router-link
                            to="/account"
                            class="header-drop__dropper__comp__info__list__item my-account"
                            @click="handleDropper"
                        >
                            <div class="my-account__avatar">
                                <VueFeather type="user" size="16" stroke="#fff" />
                            </div>
                            <span>Mitt konto</span>
                        </router-link>
                        <li
                            v-if="superAdminUserProfile"
                            class="header-drop__dropper__comp__info__list__item my-account"
                            @click="() => handleSwitchProfile(superAdminUserProfile.id)"
                        >
                            <div class="my-account__avatar">
                                <VueFeather type="user" size="16" stroke="#fff" />
                            </div>
                            <span>Superadmin</span>
                        </li>
                    </ul>
                </div>
                <ul v-if="currentDepartment && (isCertifier || isEmployAdmin)" class="header-drop__dropper__comp__menu">
                    <template v-if="currentDepartment?.type === DepartmentType.Educate">
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'certificate' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                @click="handleDropper"
                            >
                                Alla certifikat
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'create-certificate' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                @click="handleDropper"
                            >
                                Utfärda certifikat
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'settings' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera Företags- och certifikatsuppgifter"
                                @click="handleDropper"
                            >
                                Företags- och certifikatsuppgifter
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'users' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera användare"
                                @click="handleDropper"
                            >
                                Användare
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'competencies' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera kompetenser"
                                @click="handleDropper"
                            >
                                Kompetenser
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'clients' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera kund"
                                @click="handleDropper"
                            >
                                Kunder
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'payment' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera Konto och betalning"
                                @click="handleDropper"
                            >
                                Abonnemang och betalning
                            </router-link>
                        </li>
                    </template>
                    <template v-if="currentDepartment?.type === DepartmentType.Employ">
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'employ-dashboard' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                @click="handleDropper"
                            >
                                Översikt
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'employ-certificate' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                @click="handleDropper"
                            >
                                Alla certifikat
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'employ-create-certificate' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                @click="handleDropper"
                            >
                                Utfärda certifikat
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'employ-competences' }"
                                active-class="active"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Skapa nya certifikat manuellt eller via fil"
                                @click="handleDropper"
                            >
                                Roller och kompetenser
                            </router-link>
                        </li>
                        <li class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'employ-employees' }"
                                active-class="active"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Se och hantera dina medarbetare"
                                @click="handleDropper"
                            >
                                Medarbetare
                            </router-link>
                        </li>
                        <li v-if="userPermissions?.settings?.read" class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'employ-settings' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera Företags- och certifikatsuppgifter"
                                @click="handleDropper"
                            >
                                Företags- och certifikatsuppgifter
                            </router-link>
                        </li>
                        <li v-if="userPermissions?.payments?.read" class="header-drop__dropper__comp__menu__item">
                            <router-link
                                :to="{ name: 'payment' }"
                                class="header-drop__dropper__comp__menu__item__link"
                                title="Editera Konto och betalning"
                                @click="handleDropper"
                            >
                                Abonnemang och betalning
                            </router-link>
                        </li>
                    </template>
                </ul>
            </div>

            <div class="header-drop__dropper__user">
                <router-link to="/account" class="header-drop__dropper__user__link" @click="handleDropper">
                    Mitt konto
                </router-link>

                <button class="header-drop__dropper__user__btn btn btn--border btn--small" @click="handleLogout()">
                    Logga ut
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, computed } from 'vue';
    import { useStore } from 'vuex';
    import { DepartmentType } from '@enums/DepartmentType';
    import { isMobileOrTablet, ROLES } from '@/helpers';
    import usePermissions from '@composables/usePermissions';
    import { useRouter } from 'vue-router';
    import VueFeather from 'vue-feather';

    export default {
        components: {
            VueFeather,
        },
        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
        },
        emits: ['isOpen'],
        setup() {
            const store = useStore();
            const userPermissions = usePermissions();
            const companyDropDownOpen = ref(false);
            const profileDropDownOpen = ref(false);
            const isMobile = isMobileOrTablet();
            const isTogglerToggled = ref(false);

            const router = useRouter();

            const meta = computed(() => store.getters['SettingStore/GET_META']);
            const user = computed(() => store.getters['UserStore/GET_USER']);
            const departmentsWithSignInAccess = computed(
                () => store.getters['Departments/GET_DEPARTMENTS_WITH_SIGN_IN_ACCESS']
            );
            const acceptedDepartments = computed(() => store.getters['Departments/GET_ACCEPTED_DEPARTMENTS']);
            const currentDepartment = computed(() => store.getters['Departments/GET_CURRENT_DEPARTMENT']);

            const userProfiles = computed(() => store.getters['UserStore/GET_USER_PROFILES']);
            const superAdminUserProfile = computed(() => {
                return userProfiles.value.find((profile) => profile.system_role?.id === ROLES.SUPER_ADMIN);
            });

            const isEmployAdmin = computed(() => store.getters['UserStore/CAN_USER']('employ.*'));
            const isCertifier = computed(() => store.getters['UserStore/CAN_USER']('certificate.*'));

            const menuLabel = computed(() => {
                if (currentDepartment.value && currentDepartment.value.display_name) {
                    return currentDepartment.value.display_name;
                } else if (user.value && user.value.first_name) {
                    return `${user.value.first_name} ${user.value.last_name}`;
                }
                return '';
            });

            const companyClasses = computed(() => {
                let classes = 'header-drop__dropper__comp__info';

                if (companyDropDownOpen.value) {
                    classes += ' header-drop__dropper__comp__info--open';
                }

                if (departmentsWithSignInAccess.value.length === 0 && !superAdminUserProfile.value) {
                    classes += ' header-drop__dropper__comp__info--alone';
                }

                return classes;
            });

            const profileClasses = computed(() => {
                let classes = 'header-drop__dropper__comp__info';

                if (profileDropDownOpen.value) {
                    classes += ' header-drop__dropper__comp__info--open';
                }

                if (user.value && user.value?.profiles && user.value?.profiles.length <= 1) {
                    classes += ' header-drop__dropper__comp__info--alone';
                }

                return classes;
            });

            const handleDropper = () => {
                store.commit('GlobalStore/SET_HEADER_DROPDOWN');
                isTogglerToggled.value = !isTogglerToggled.value;
            };

            const handleCompanyDropdown = () => (companyDropDownOpen.value = !companyDropDownOpen.value);
            const handleProfileDropdown = () => (profileDropDownOpen.value = !profileDropDownOpen.value);
            const handleSwitchCompany = async (department) => {
                if (department.id === currentDepartment.value?.id) return;

                store.commit('GlobalStore/SET_LOADING', true);

                try {
                    await Promise.all([
                        store.dispatch('Departments/CHANGE_DEPARTMENT', department?.id),
                        store.dispatch('UserStore/CHANGE_PROFILE', department?.user_profile?.id),
                        store.dispatch('UserStore/GET_ME'),
                    ]);

                    window.dispatchEvent(new CustomEvent('pagination.update.data'));
                    window.dispatchEvent(new CustomEvent('statistics.update.data'));

                    await router.push({ name: 'login' }); // Redirect to the correct landing page
                } finally {
                    handleDropper();
                    setTimeout(() => store.commit('GlobalStore/SET_LOADING', false), 1000);
                }
            };

            async function maybeSwitchToSuperadmin(id) {
                if (superAdminUserProfile.value && superAdminUserProfile.value.id === id) {
                    let user = JSON.parse(localStorage.getItem('system_cache'));
                    user.currentDepartment = null;
                    user.department_id = null;

                    localStorage.setItem('system_cache', JSON.stringify(user));

                    await router.push({ name: 'superadmin' });
                }
            }

            const handleSwitchProfile = async (id) => {
                if (id === user.value.current_profile_id) return;

                await store.commit('GlobalStore/SET_LOADING', true);
                await store.dispatch('UserStore/CHANGE_PROFILE', id);

                await maybeSwitchToSuperadmin(id);

                await store.dispatch('UserStore/GET_ME');
                location.reload();
            };

            const handleLogout = () => store.dispatch('UserStore/LOGOUT_USER');

            return {
                DepartmentType,
                companyDropDownOpen,
                profileDropDownOpen,
                meta,
                user,
                departmentsWithSignInAccess,
                acceptedDepartments,
                currentDepartment,
                superAdminUserProfile,
                menuLabel,
                companyClasses,
                profileClasses,
                isEmployAdmin,
                isCertifier,
                handleDropper,
                handleCompanyDropdown,
                handleProfileDropdown,
                handleSwitchCompany,
                handleSwitchProfile,
                handleLogout,
                isMobile,
                isTogglerToggled,
                userPermissions: userPermissions.get(),
            };
        },
    };
</script>

<style scoped lang="scss">
    .display-toggle {
        display: inline-block;
        transform: translate(8px, 0);
    }

    .my-account {
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        color: #02354a;
        text-decoration: none;

        &__avatar {
            display: inline-flex;
            width: 32px;
            height: 32px;
            padding: 8px;
            justify-content: center;
            align-items: center;
            background: #349a87;
            border-radius: 100%;
        }

        > span {
            margin-left: 8px;
        }
    }
</style>
